type ZipEmailLeadResponseData = {
    result: string;
    invalidFields: string[];
};

export const createLead = async ({ email, zip, trackingStatus }: ZipEmailLeadRequestArgs) => {
    try {
        const data = new URLSearchParams();
        data.append('leadRequest.email', email);
        data.append('leadRequest.zip', zip);
        data.append('leadRequest.trackingStatus', trackingStatus);
        const req = await fetch(
            `https://www.${process.env.GATSBY_SUBDOMAIN || ''}ehealthinsurance.com/ehi/ifp/oep-lead!saveForNewHouse`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: data,
            }
        );

        if (!req.ok) {
            throw `${req.status} - ${req.statusText}`;
        }

        const resp = (await req.json()) as ZipEmailLeadResponseData;

        if (resp.result !== 'SUCCESS') {
            const invalidFields = resp.invalidFields.join(', ');
            throw `[${resp.result}] - [Invalid fields] - ${invalidFields}`;
        }

        return resp;
    } catch (error) {
        console.error('[ZipEmailLeadForm][createLead]:', error);
        throw error;
    }
};
